export default __webpack_public_path__ + "static/media/entertain2.b52f5aed.jpeg";